<template>

<div class="container">
 
    <div class="card mt-4 ">
      <div class="card-header text-right">
      <span> مرحباً  </span>
      <span> : </span>
      <span class="text-warning"> {{name}} </span>
   
      </div>
<div class="card-body">
  <div class="row justify-content-md-center">
<div class="col-3 wedgit p-4 text-center mar">
  <div class="text-center">
<i class="fa fa-graduation-cap pl-1 logo" ></i>
  </div>
<span>عدد الطلاب</span>
<div class="text-center"><span class="num">100</span>
</div>
</div>
<div class="col-3 wedgit2 p-4 text-center mar">
  <div class="text-center">
<i class="fa fa-user-tie pl-1 logo" ></i>
  </div>
<span>عدد السائقين</span>
<div class="text-center"><span class="num">50</span></div>
</div>
<div class="col-3 wedgit3 p-4 text-center mar">
  <div class="text-center">
<i class="fa fa-bus pl-1 logo" ></i>
  </div>
<span>عدد الحافلات</span>
<div class="text-center"><span class="num">10</span></div>

</div>
  </div>
  
  <div class="row">
    
<div class="col-12 labl"><span>إحصاء بعدد الطلاب والحافلات</span></div>

    <div class="col-6"><AreaChart/></div>
    <div class="col-6"><PieChart/></div>
    <div class="col-6"><BarChart/></div>
    <div class="col-6"><RadarChart/></div>
    <div class="col-6"><LineChart/></div>
     
    </div>
</div>
    </div>
</div>
</template>

<script>
import{mapGetters} from 'vuex'
import AreaChart from "../components/charts/AreaChart.vue";
import PieChart from "../components/charts/PieChart.vue";
import BarChart from "../components/charts/BarChart.vue";
import RadarChart from "../components/charts/RadarChart.vue";
import LineChart from "../components/charts/LineChart.vue";
import indexLayout from "../layouts/indexLayout.vue";

export default {
  name: "Home",
  computed:{
...mapGetters({
  name:'GET_NAME'
})
  },
  components: {
    AreaChart,
    PieChart,
    BarChart,
    RadarChart,
    LineChart
    },
    data () {
      return {
         chartData: {
        Books: 24,
        Magazine: 30,
        Newspapers: 10
      }
      }
    },
    created(){
      this.$emit('update:layout',indexLayout)
    },
    mounted () {
     
    },
    methods: {
     
    }
 
};
</script>
<style lang="scss" scoped>

 .card-body {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
 
}
.card{
min-height: 400px;
margin-bottom: 20px;
}
.wedgit{
  height: 150px;
    background-image: radial-gradient(circle 248px at center, #19f4ff 0%, #30c7ec 47%, #46aef7 100%) !important;}
.wedgit2{
  height: 150px;
background-image: radial-gradient(circle 248px at center, #80ffb9 0%, #59fd95 47%, #48de4e 100%) !important;}
.wedgit3{
  height: 150px;
background-image: radial-gradient(circle 248px at center, #ffbaba 0%, #ff9d9d 47%, #ff9a9a 100%) !important;}
.logo{
    font-size: 60px;
    color:#fff;
}
.num{
    font-size: 20px;
    color:#d45112;
}
.labl{
  margin-top: 5px;
    padding-top: 5px;
    height: 30px;
    background-color: #c1c1c1;
}
.mar{
  margin: 0px 2%;
}
</style>
